import { createStyles, makeStyles } from '@mui/styles';
import { FormatItalic, Send } from '@mui/icons-material';
import {
  CcfAlignLeftIcon,
  CcfAlignCenterIcon,
  CcfAlignRightIcon,
  CcfButton,
  CcfGifIcon,
  CcfEmojiIcon,
  CcfFormatBoldIcon,
  CcfUploadIcon,
  CcfImageIcon,
} from '@nice-ccf/ui-controls';
import { CONVERSATION_CONTAINER_FOOTER_HEIGHT } from '../utils/conversations.utils';

const useStyles = makeStyles(() =>
  createStyles({
    footerContainer: {
      display: 'flex',
      justifyContent: 'space-between',
      paddingInline: 8,
      marginTop: 4,
      marginBottom: 8,
      height: CONVERSATION_CONTAINER_FOOTER_HEIGHT,
    },
    customButton: {
      minWidth: 40,
      marginRight: '8px',
    },
    customSendButton: {
      minWidth: 40,
      background: '#F5F8FA 0% 0% no-repeat padding-box',
      border: '1px solid #DAE2E8',
      borderRadius: '3px',
    },
  })
);

/**
 * Component for footer of conversation
 * @example <ConversationsFooter />
 * @returns
 */
export const ConversationsAppFooter = () => {
  const styles = useStyles();
  return (
    <footer className={styles.footerContainer}>
      <div
        style={{
          width: '30%',
          display: 'flex',
          justifyContent: 'space-between',
        }}
      >
        <CcfButton
          color="secondary"
          size="small"
          classes={{ root: styles.customButton }}
        >
          <CcfUploadIcon />
        </CcfButton>
        <CcfButton
          color="secondary"
          size="small"
          classes={{ root: styles.customButton }}
        >
          <CcfFormatBoldIcon />
        </CcfButton>
        <CcfButton
          color="secondary"
          size="small"
          classes={{ root: styles.customButton }}
        >
          <FormatItalic />
        </CcfButton>
        <CcfButton
          color="secondary"
          size="small"
          classes={{ root: styles.customButton }}
        >
          <CcfAlignLeftIcon viewBox="0 0 20 20" />
        </CcfButton>
        <CcfButton
          color="secondary"
          size="small"
          classes={{ root: styles.customButton }}
        >
          <CcfAlignCenterIcon viewBox="0 0 20 20" />
        </CcfButton>
        <CcfButton
          color="secondary"
          size="small"
          classes={{ root: styles.customButton }}
        >
          <CcfAlignRightIcon viewBox="0 0 20 20" />
        </CcfButton>
      </div>

      <div style={{ width: '25%', display: 'flex', justifyContent: 'center' }}>
        <CcfButton
          color="secondary"
          size="small"
          classes={{ root: styles.customButton }}
        >
          <CcfImageIcon />
        </CcfButton>
        <CcfButton
          color="secondary"
          size="small"
          classes={{ root: styles.customButton }}
        >
          <CcfEmojiIcon />
        </CcfButton>
        <CcfButton
          color="secondary"
          size="small"
          classes={{ root: styles.customButton }}
        >
          <CcfGifIcon />
        </CcfButton>
        <div style={{ marginTop: '10px', marginRight: 8 }}>
          <CcfButton
            variant="outlined"
            color="secondary"
            size="small"
            classes={{ root: styles.customSendButton }}
          >
            <Send />
          </CcfButton>
        </div>
      </div>
    </footer>
  );
};
